import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { components as Core, translate } from '../../../core'
import { FEATURES } from '../../constants'
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import { css, colors, common, fonts, spacing, StyleSheet } from '../../../../styles';

class CompanyFeaturesModal extends React.PureComponent {
    static propTypes = {
        companyId: PropTypes.string.isRequired,
        companyFeatures: PropTypes.array.isRequired,
        i18n: PropTypes.object.isRequired,
        actions: PropTypes.object.isRequired,
        onClose: PropTypes.func,
        isEmbedded: PropTypes.bool
    };

    static defaultProps = {
        isEmbedded: false,
        onClose: null
    };

    constructor(props) {
        super(props);
        this.state = {
            currentCompanyFeatures: this.props.companyFeatures
        };
    }

    get data() {
        const { currentCompanyFeatures } = this.state;
        const { i18n } = this.props;
        const sortedFeatures = _.sortBy(FEATURES, feature => i18n.t(feature.name).toLowerCase());

        return _.map(sortedFeatures, ({ name, value }) => ({
            name,
            bitValue: value,
            value: (currentCompanyFeatures & value) !== 0
        }));
    }

    get isUpdatedState() {
        const { companyFeatures } = this.props;
        const { currentCompanyFeatures } = this.state;
        return companyFeatures !== currentCompanyFeatures;
    }

    toggleFeature = data => {
        this.setState(prevState => ({
            currentCompanyFeatures:
            data.inActive ? prevState.currentCompanyFeatures & ~data.bitValue : prevState.currentCompanyFeatures | data.bitValue
        }));
    }

    onUpdateCompanyFeatures = () => {
        const { companyId } = this.props;
        this.props.actions.updateCompanyFeature(companyId, this.state.currentCompanyFeatures);
    }

    renderFeatureItem = ({ bitValue, name, value }) => {
        const { i18n } = this.props;
        return (
            <div className={css(styles.featureItem)} key={bitValue}>
                <span className={css(styles.featureName)}>{i18n.t(name)}</span>
                <Core.Checkbox
                    checked={value}
                    onToggle={this.toggleFeature}
                    data={{ bitValue, inActive: value }}
                />
            </div>
        );
    }

    render() {
        const { i18n, isEmbedded, onClose } = this.props;
        const content = (
            <>
                <section className={css(styles.featureSection)}>
                    <h3 className={css(styles.featureTitle)}>{i18n.t('companies.features.features')}</h3>
                    <div className={css(styles.featureGrid)}>{this.data.map(this.renderFeatureItem)}</div>
                </section>
                <div className={css(common.flexRowCenter)}>
                    {this.isUpdatedState ? (
                        <Core.Button
                            label={i18n.t('setupSettings.save')}
                            onPress={this.onUpdateCompanyFeatures}
                        />
                    ): null
                    }
                </div>
            </>
        );

        if (isEmbedded) return content;

        return (
            <Core.Modal
                isVisible={true}
                title={this.renderTitle}
                onClose={onClose}>
                {content}
            </Core.Modal>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch)
});

const mapStateToProps = (state, ownProps) => ({
    companyFeatures: selectors.getCompanyFeatures(state, ownProps.companyId)
});

export default connect(mapStateToProps, mapDispatchToProps)(translate()(CompanyFeaturesModal));

const styles = StyleSheet.create({
    featureSection: {
        marginTop: spacing.s4
    },
    featureTitle: {
        ...fonts.mdBold,
        color: colors.black,
        marginBottom: spacing.s3
    },
    featureGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        gap: spacing.s2,
        '@media (max-width: 640px)': {
            gridTemplateColumns: 'minmax(0, 1fr)'
        }
    },
    featureItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: spacing.s1,
        minWidth: 0,
        padding: spacing.s2,
        border: `1px solid ${colors.border}`,
        borderRadius: spacing.s1
    },
    featureName: {
        ...fonts.smNormal,
        color: colors.black,
        overflowWrap: 'anywhere'
    }
});
